import Sentry from "@similarweb/sentry-logger";

import type TrafficSignalFilters from "../../../models/traffic/TrafficSignalFilters";
import type UISignal from "../../../models/view/UISignal";
import type UISignalDeps from "../../../models/view/UISignalDeps";
import type UISignalFactory from "../UISignalFactory";

import createTrafficUISignalNameBuilder from "./trafficUISignalNameBuilder";

const trafficUISignalFactory: UISignalFactory<TrafficSignalFilters> = {
    createUISignal(deps: Readonly<UISignalDeps<TrafficSignalFilters>>): Readonly<UISignal<TrafficSignalFilters>> {
        const { numberOfAccounts, signal, template } = deps;
        const { alias, description, name, signalSubType, timeframeConfig, signalLifecycleState } = template;
        const nameBuilder = createTrafficUISignalNameBuilder({ countries: deps.countries });

        return {
            ...signal,
            numberOfAccounts,
            signalSubType,
            timeframeConfig,
            signalLifecycleState,
            get name() {
                try {
                    return nameBuilder.buildName(signal, template);
                } catch (e) {
                    Sentry.error(e.message, e);

                    return name;
                }
            },
            get nameSegments() {
                try {
                    return nameBuilder.buildNameSegments(signal);
                } catch (e) {
                    Sentry.error(e.message, e);

                    return {
                        signalType: {
                            key: "",
                        },
                    };
                }
            },
            template: { alias, description, name },
            selectionTooltipLabels: nameBuilder.buildSelectionTooltipLabels(signal),
        };
    },
};

export default trafficUISignalFactory;
